import { createUseStyles } from 'react-jss';

import { hideScrollbars, mediaQuery } from '../../../styles';
import { ITheme } from '../../../styles/theme';

export default createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      '--switcherItemWidth': 'auto',

      display: 'flex',
      justifyContent: 'center',
      position: 'relative',
      zIndex: 101,
    },
    scrollable: {
      display: 'flex',
      maxWidth: '100%',
      width: 'fit-content',
      ...hideScrollbars,

      [mediaQuery(breakpoints.tablet)]: {
        overflow: 'auto',
      },
    },
    container: {
      backgroundColor: '#EAECF3',
      borderRadius: 24,
      display: 'flex',
    },
    items: {
      alignItems: 'center',
      backgroundColor: 'var(--x-bg-1)',
      borderRadius: 24,
      border: '2px solid var(--x-accent-2-5)',
      display: 'flex',
      fontSize: 14,
      padding: 4,
    },
    buttonContainer: {
      position: 'relative',

      '&:hover': {
        '& $tooltipContainer': {
          display: 'inline-flex',
          justifyContent: 'center',
        },

        [mediaQuery(breakpoints.tablet)]: {
          '& $tooltipContainer': {
            display: 'none',
          },
        },
      },
    },
    tooltipContainer: {
      position: 'absolute',
      width: '100%',
      whiteSpace: 'nowrap',
      top: 'calc(100% + 9px)',
      right: 0,
      display: 'none',
      zIndex: 100,
    },
    button: {
      fontWeight: 600,
      color: 'var(--x-accent-2-1)',
      display: 'inline-block',
      whiteSpace: 'nowrap',
      cursor: 'pointer',
      padding: [7, 27],
      textAlign: 'center',
      width: '100%',
    },
    selected: {
      backgroundColor: 'var(--x-accent-2-5)',
      borderRadius: 24,
      cursor: 'default',
    },
    marginItem: {
      alignItems: 'center',
      display: 'flex',
      fontWeight: 600,
      fontSize: '14px',
      justifyContent: 'center',
      flexGrow: 1,
      textAlign: 'center',
      padding: [7, 27],
    },
  }),
  { name: 'AppSwitcher' },
);
